// Formats a timestamp for display as a relative day plus wall-clock time, without seconds:
//   "Today, 12:37 PM", "Yesterday, 5:40 PM", and the date for anything older ("10/8/2026, 5:40 PM").
//
// Display only - the value itself (seconds included) is untouched, so anything that sorts or compares
// on it keeps full precision. Use formatFullDateTime for a hover title that still shows the seconds.
//
// Days are calendar days in the viewer's time zone, not 24-hour spans: 12:05 AM is "Today" and
// 11:55 PM the night before is "Yesterday", which is how someone reading the column thinks about it.
// Future times (clock skew) fall through to the plain date.
export function formatRelativeDateTime(value, empty = '—') {
    const parsed = toDate(value);
    if (!parsed) return empty;

    const time = parsed.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });

    const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
    const daysAgo = Math.round((startOfDay(new Date()) - startOfDay(parsed)) / 86400000);

    if (daysAgo === 0) return `Today, ${time}`;
    if (daysAgo === 1) return `Yesterday, ${time}`;
    return `${parsed.toLocaleDateString()}, ${time}`;
}

// Full local date and time including seconds, e.g. for a title tooltip next to formatRelativeDateTime.
export function formatFullDateTime(value) {
    const parsed = toDate(value);
    return parsed ? parsed.toLocaleString() : '';
}

function toDate(value) {
    if (value === null || value === undefined || value === '') return null;
    const parsed = value instanceof Date ? value : new Date(value);
    return isNaN(parsed.getTime()) ? null : parsed;
}
